var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_vm._t("card-header"),_c('v-card-text',[_vm._t("header"),_c('custom-jodit-editor',{attrs:{"config":_vm.editorConfig},on:{"input":_vm.handleEditorInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._t("bottom-content"),_vm._t("bottom-buttons")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }